import { AppThunk } from '@/store'
import { createAction, request } from '@/store/actions'

import {
  FETCH_PUBLISHER_ANALYTICS,
  FETCH_PUBLISHER_NOTIFICATION_LOGS,
  FETCH_SYSTEM_CONNECTOR_ACTIVITY,
  RESET_CSV_URLS
} from './actionTypes'

export const fetchToolbarAnalyticsMetrics = (params: any, notificationId: string): AppThunk => {
  return dispatch =>
    dispatch(
      request(
        `/analytics/spaces/:spaceId/notification/${notificationId}/usage?oldest=${params.oldest}&latest=${
          params.latest
        }${params.difference ? `&difference=${params.difference}` : ''}`,
        FETCH_PUBLISHER_ANALYTICS,
        {},
        { args: { spaceId: ':spaceId', notificationId }, service: 'audit' }
      )
    )
}

export const fetchSystemConnectorsMetrics = (params: any, notificationId: string): AppThunk => {
  // Note that `notificationId` is the "publisher/survey" notificationId which is actually the correlationId
  // This is used to "group" the series of notifications together (many "real" notificationIds to one correlationId)
  // From ticket: https://forge.lmig.com/issues/browse/ETSWORK-11871 we now accept correlationId as the param for analytics
  return dispatch =>
    dispatch(
      request(
        `/analytics/spaces/:spaceId/notification?correlationId=${notificationId}&oldest=${params.oldest}&latest=${
          params.latest
        }${params.difference ? `&difference=${params.difference}` : ''}`,
        FETCH_SYSTEM_CONNECTOR_ACTIVITY,
        {},
        { args: { spaceId: ':spaceId' }, service: 'audit' }
      )
    )
}

export const fetchNotificationLogs = (search: object): AppThunk => {
  return dispatch => {
    dispatch(
      request(
        '/publisher/spaces/:spaceId/logs',
        FETCH_PUBLISHER_NOTIFICATION_LOGS,
        { search },
        { args: { spaceId: ':spaceId' }, service: 'audit' }
      )
    )
  }
}

export const resetGeneratedCSVUrls = (): AppThunk => {
  return dispatch => {
    dispatch(createAction(RESET_CSV_URLS))
  }
}
